import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/core/styles';
import featureFlags from '../../lib/FeatureFlags';

const style = (theme) => ({
    root: {
        position: 'fixed',
        bottom: 30,
        right: 30,
    },
    icon: {
        marginRight: theme.spacing(1)
    }
});

const FloatingActionButton = props => {
    return (
        <Fab
            className={props.classes.root}
            variant="extended"
            color="secondary"
            onClick={props.onClick}
            disabled={props.disabled}
            style={props.styleOverride}
        >
            <span className={props.classes.icon}>
                {props.icon}
            </span>
            {props.text}
        </Fab>
    );
};

FloatingActionButton.propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
    }).isRequired,
    styleOverride: PropTypes.shape({
        root: PropTypes.string,
        icon: PropTypes.string,
    }),
};

FloatingActionButton.defaultProps = {
    icon: null,
    onClick: () => {},
    disabled: false,
    styleOverride: null,
};

export default withStyles(style)(FloatingActionButton);
